module.exports = __webpack_public_path__ + "img/HC_OL.8366bbaa.svg";